export default __webpack_public_path__ + "static/media/centurion.5d92acd4.webp";